import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const StaticWorkspaceRouteLazy = lazyWithRetry(() => import('./StaticWorkspace'));
export function StaticWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <StaticWorkspaceRouteLazy />
    </Suspense>
  );
}
